const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/service_hosp/EmptyRouterView.vue");
const Administrative = () => /* webpackChunkName: "Home" */ import("./../views/service_hosp/Home.vue");
const ArchiveRequest = () => /* webpackChunkName: "ArchiveRequestHome" */ import("./../views/service_hosp/ArchiveRequestHome.vue");
const Document = () => /* webpackChunkName: "Document" */ import("@/views/general/Document.vue");

export const routes = [
  {
    path: "/serviceHosp",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "serviceHospHome",
        component: Administrative,
      },
      {
        path: "archivo",
        name: "serviceHospArchiveRequest",
        component: ArchiveRequest,
      },
      {
        path: "documentacion",
        name: "serviceHopsDocumentation",
        component: Document,
      },
    ],
  },
];
